
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {},
})
export default class Version extends Vue {
  @Getter("version") public version: string;
  public mounted() {
    // eslint-disable-next-line no-console
    console.debug("version:", this.version);
  }
}
